import Wahanda from 'common/wahanda';
import { QuoteSummaryData, isVoidQuote, isVoidQuoteEntry } from 'services/quote-daily-report';

export const getLangs = () => ({
  quote: Wahanda.lang.reports.transactions.quoteSummary,
  voidEntry: Wahanda.lang.reports.transactions.voidQuoteSummary,
});

export const getQuoteSummaryLabels = (isVoidTableEntry: boolean) => {
  const { quote, voidEntry } = getLangs();
  const lang = isVoidTableEntry ? voidEntry : quote;

  return {
    dialogTitle: lang.dialogTitle,
    employeeLabel: isVoidTableEntry ? lang.voidedBy : lang.createdBy,
    totalLabel: isVoidTableEntry ? lang.voidQuoteTotal : lang.quoteTotal,
    copyLabel: isVoidTableEntry ? lang.voidQuoteCopy : lang.quoteCopy,
    copyDataTest: isVoidTableEntry ? 'quote-summary-voided-quote-copy' : 'quote-summary-quote-copy',
    dialogDataTest: isVoidTableEntry
      ? 'report-void-quote-summary-modal'
      : 'report-quote-summary-modal',
  };
};

export const getQuoteSummaryDisplay = (data: QuoteSummaryData | null) => {
  const isVoidTableEntry = data ? isVoidQuoteEntry(data) : false;
  return { isVoidTableEntry, labels: getQuoteSummaryLabels(isVoidTableEntry) };
};

export const getBannerMessage = (normalizedData: QuoteSummaryData): string | null => {
  if (!isVoidQuote(normalizedData) || isVoidQuoteEntry(normalizedData)) {
    return null;
  }

  return getLangs().quote.voidQuoteMessage ?? null;
};
